export const WARRANTY_LENGTH_OPTIONS = [
  { id: 1, value: 0, label: 'No Warranty', testId: 'proposal-won-warranty-option-0' },
  { id: 2, value: 30, label: '30 Days', testId: 'proposal-won-warranty-option-30' },
  { id: 3, value: 60, label: '60 Days', testId: 'proposal-won-warranty-option-60' },
  { id: 4, value: 90, label: '90 Days', testId: 'proposal-won-warranty-option-90' },
  { id: 5, value: 180, label: '180 Days', testId: 'proposal-won-warranty-option-180' },
  { id: 6, value: 365, label: '1 Year', testId: 'proposal-won-warranty-option-365' },
];
